import React, { useEffect, useRef } from 'react';
import './FeaturesSection.css';
import ElectricTimeline from './ElectricTimeline';

const FeaturesSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);

  // Intersection Observer para animação de scroll
  useEffect(() => {
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const timelineCards = [
    {
      id: 'renovacoes',
      title: '+ renovações',
      t: 0.20,
      offsetY: 48
    },
    {
      id: 'cac',
      title: '- CAC',
      t: 0.32,
      offsetY: -60
    },
    {
      id: 'crosssell',
      title: 'x-sell imediata',
      t: 0.50,
      offsetY: 40
    },
    {
      id: 'churn',
      title: '- churn',
      t: 0.65,
      offsetY: -50
    },
    {
      id: 'rgpd',
      title: 'Tudo em conformidade',
      t: 0.82,
      offsetY: 50
    }
  ];

  return (
    <section ref={sectionRef} id="recursos">
      {/* Nova timeline elétrica - full width */}
        <ElectricTimeline cards={timelineCards} />

      <div className="container">
      </div>
    </section>
  );
};

export default FeaturesSection;